import { render } from "./INaturalistWidget.vue?vue&type=template&id=3d2e25fb"
import script from "./INaturalistWidget.vue?vue&type=script&lang=js"
export * from "./INaturalistWidget.vue?vue&type=script&lang=js"

import "./INaturalistWidget.vue?vue&type=style&index=0&id=3d2e25fb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__